export function initAuthRegister() {
    const innInput = document.getElementById('register-inn-input');
    const previewEl = document.getElementById('register-inn-preview');
    if (!innInput || !previewEl) return;

    let lastInn = '';
    let lastController = null;

    function esc(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    function setPreview(html, isError) {
        previewEl.innerHTML = html || '';
        if (!html) { previewEl.classList.add('hidden'); return; }
        previewEl.classList.remove('hidden');
        previewEl.classList.toggle('text-red-700', !!isError);
        previewEl.classList.toggle('text-slate-600', !isError);
        previewEl.classList.toggle('border-red-200', !!isError);
        previewEl.classList.toggle('bg-red-50', !!isError);
        previewEl.classList.toggle('border-slate-200', !isError);
        previewEl.classList.toggle('bg-slate-50', !isError);
    }

    function lookupInn() {
        let inn = innInput.value.replace(/\D+/g, '');
        if (!inn || inn.length < 10) { setPreview('', false); lastInn = ''; return; }
        if (inn === lastInn) return;
        lastInn = inn;
        if (lastController) lastController.abort();
        const controller = new AbortController();
        lastController = controller;
        setPreview('Проверяем ИНН по базе организаций...', false);

        fetch('/api/auth/inn-lookup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': window.getCsrfToken() },
            body: JSON.stringify({ inn: inn }),
            signal: controller.signal
        }).then(function (res) {
            return res.json().then(function (data) { return { status: res.status, body: data }; });
        }).then(function (res) {
            const body = res.body || {};
            if (body.ok) {
                const org = body.organization || {};
                const name = org.nameShort || org.nameFull || '';
                const region = org.region || '';
                const city = org.city || '';
                const location = [region, city].filter(Boolean).join(', ');
                let statusHtml;
                if (!org.status || org.status === 'ACTIVE') {
                    statusHtml = '<div class="mt-1 flex items-center gap-1.5 text-[11px] text-emerald-700"><span class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-emerald-100 text-emerald-700"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="w-3 h-3"><path d="M2 8.5 6.5 13 14 3"/></svg></span><span>Действующая организация</span></div>';
                } else {
                    statusHtml = '<div class="mt-1 text-[11px] text-slate-500">Статус: ' + esc(String(org.status)) + '</div>';
                }
                const html = [
                    name ? '<div class="text-xs font-medium text-slate-900">' + esc(name) + '</div>' : '',
                    location ? '<div class="mt-0.5 text-[11px] text-slate-600">' + esc(location) + '</div>' : '',
                    statusHtml
                ].join('');
                setPreview(html, false);
                return;
            }
            setPreview(body.error || 'Не удалось проверить ИНН.', true);
        }).catch(function (err) {
            if (err.name === 'AbortError') return;
            setPreview('Не удалось проверить ИНН. Попробуйте позже.', true);
        });
    }

    innInput.addEventListener('blur', lookupInn);
    innInput.addEventListener('change', lookupInn);
}
